<template>
    <div>
        <a-spin :spinning="spinning">
            <h6 v-if="(targetKey < 0)" class="heading-small text-muted mb-4">Add New Site Price</h6>
            <h6 v-else class="heading-small text-muted mb-4">Edit Site Price</h6>
            <base-alert v-if="errors.length" type="danger">
                <b>You have the following error(s):</b>
                <li v-for="error in errors" :key="error">{{ error }}</li>
            </base-alert>

            <form id="form-proper">
                <base-input label="Select Site" required>
                    <a-select v-if="targetKey < 0" v-model="inputSiteId" showSearch placeholder="Enter Site" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :disabled="isSiteSelectionLocked">
                        <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                    </a-select>

                    <a-select v-else v-model="inputSiteId" showSearch placeholder="Enter Site" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" disabled>
                        <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                    </a-select>
                </base-input>

                <base-input label="Primary Supplier" required >
                    <a-select v-model="inputSupplierId" showSearch placeholder="Enter Primary Supplier" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :disabled="fieldReadOnly">
                        <a-select-option v-for="option in supplierOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                    </a-select>
                </base-input>

                <div class="form-group has-label">
                    <label class="form-control-label">Original Cost</label>
                    <input type="number" class="form-control" v-model="inputOriginalCost" min="0" placeholder="Enter Original Cost" name="original" @change="changeAmount" :disabled="fieldReadOnly"/>
                    <input type="hidden" class="form-control" v-model="inputOldOriginalCost" min="0" placeholder="Enter Old Original Cost" name="original" @change="changeAmount"/>
                </div>
                <div class="form-group has-label">
                    <label class="form-control-label">Ordering Cost</label>
                    <input type="number" class="form-control" v-model="inputOrderingCost" min="0" placeholder="Enter Ordering Cost" name="ordering" @change="changeAmount" :disabled="fieldReadOnly"/>
                    <input type="hidden" class="form-control" v-model="inputOldOrderingCost" min="0" placeholder="Enter Old Ordering Cost" name="ordering" @change="changeAmount"/>
                </div>
                <div class="form-group has-label">
                    <label class="form-control-label">Landed Cost</label>
                    <input type="number" class="form-control" v-model="inputLandedCost" min="0" placeholder="Enter Landed Cost" name="landed" @change="changeAmount" :disabled="fieldReadOnly"/>
                    <input type="hidden" class="form-control" v-model="inputOldLandedCost" min="0" placeholder="Enter Old Landed Cost" name="landed" @change="changeAmount"/>
                </div>

                <base-input label="Last Discount" placeholder="Enter Last Discount" v-model="inputLastDiscount" :disabled="fieldReadOnly" />

                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group has-label">
                            <label class="form-control-label">Retail Price</label>
                            <a-input v-model='inputRetailPrice' min="0" type='number' placeholder="Enter Retail Price" input-classes="form-control" :disabled="fieldReadOnly"/>
                            <a-input v-model='inputOldRetailPrice' min="0" type='hidden' placeholder="Enter Old Retail Price" input-classes="form-control"/>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group has-label">
                            <label class="form-control-label">Mark up</label>
                            <input type="number" class="form-control" v-model="inputMarkupRetail" min="0" placeholder="Enter Mark up" name="retail" @change="computePrice" :disabled="fieldReadOnly" />
                        </div>
                    </div>
                </div>                        

                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group has-label">
                            <label class="form-control-label">Wholesale Price</label>
                            <a-input v-model='inputWholesalesPrice' placeholder="Enter Wholesale Price" min="0" type='number' input-classes="form-control" :disabled="fieldReadOnly"/>
                            <a-input v-model='inputOldWholesalesPrice' placeholder="Enter Old Wholesale Price" min="0" type='hidden' input-classes="form-control"/>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group has-label">
                            <label class="form-control-label">Mark up</label>
                            <input type="number" class="form-control" v-model="inputMarkupWholesale" min="0" placeholder="Enter Mark up" name="wholesale" @change="computePrice" :disabled="fieldReadOnly" />
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group has-label">
                            <label class="form-control-label">Least Price</label>
                            <a-input v-model='inputLeastPrice' placeholder="Enter Least Price" min="0" type='number' input-classes="form-control" :disabled="fieldReadOnly"/>
                            <a-input v-model='inputOldLeastPrice' placeholder="Enter Old Least Price" min="0" type='hidden' input-classes="form-control"/>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group has-label">
                            <label class="form-control-label">Mark up</label>
                            <input type="number" class="form-control" v-model="inputMarkupLeast" min="0" placeholder="Enter Mark up" name="least" @change="computePrice" :disabled="fieldReadOnly" />
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group has-label">
                            <label class="form-control-label">Special Price</label>
                            <a-input v-model='inputSpecialPrice' placeholder="Enter Special Price" min="0" type='number' input-classes="form-control" :disabled="fieldReadOnly"/>
                            <a-input v-model='inputOldSpecialPrice' placeholder="Enter Old Special Price" min="0" type='hidden' input-classes="form-control"/>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group has-label">
                            <label class="form-control-label">Mark up</label>
                            <input type="number" class="form-control" v-model="inputMarkupSpecial" min="0" placeholder="Enter Mark up" name="special" @change="computePrice" :disabled="fieldReadOnly" />
                        </div>
                    </div>
                </div>

                <br><br>

                <div v-if="serverType == 'ho' || constrainedMode" style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                    <button v-if="(targetKey < 0)" type="button" class="btn btn-primary float-right" @click.prevent="create">Add Site</button> 
                    <button v-else type="button" class="btn btn-primary float-right" @click.prevent="update">Update</button>
                </div>
                <div v-else style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                    <button type="button" class="btn btn-primary float-left" @click.prevent="$emit('closeDrawer', null)">Cancel</button> 
                </div>
            </form>
        </a-spin>
    </div>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import { mapState } from 'vuex'
    
    var component_x;
    export default {
        computed: {
            ...mapState(['endPoint', 'profileId', 'serverType']),
            fieldReadOnly() {
                return this.serverType == 'branch' && !this.constrainedMode;
            },
            isSiteSelectionLocked() {
                return this.targetKey >= 0 || this.constrainedMode;
            },
        },
        mounted: async function () {
            if(this.serverType == 'branch' && !this.constrainedMode){
                var form = document.getElementById("form-proper")
                var elements = form.elements;
                for (var i = 0, len = elements.length; i < len; ++i) {
                    elements[i].readOnly = true;
                }
            }
            component_x = this
            component_x.spinning = true;

            component_x.formSettings = component_x.$attrs.formSettings;

            //set default settings
            if(component_x.formSettings.markup_computation != undefined){
                component_x.markup_computation = component_x.formSettings.markup_computation;
            }
            if(component_x.formSettings.enable_auto_compute_price_on_markup != undefined){
                component_x.enable_auto_compute_price_on_markup = component_x.formSettings.enable_auto_compute_price_on_markup;
            }
            if(component_x.formSettings.cost_decimal_places != undefined){
                if(component_x.formSettings.cost_decimal_places == "1") {
                    component_x.cost_decimal_places = 2;
                } else {
                    component_x.cost_decimal_places = 4;
                }
            }

            var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?mode=all&exclude_ho=1", null);
            component_x.siteOptions = sites;
            component_x.sort(component_x.siteOptions);
            if (this.constrainedMode) {
                component_x.siteOptions = component_x.siteOptions.filter((site) => site.id === this.currentSiteId);
                component_x.inputSiteId = this.currentSiteId;
            }

            var suppliers = await HTTPRequest.getRequest(component_x.endPoint + "suppliers/get_valid_suppliers", null);
            component_x.supplierOptions = suppliers;
            component_x.sort(component_x.supplierOptions);

            this.inputOldOriginalCost = '0'
            this.inputOldOrderingCost = '0'
            this.inputOldLandedCost = '0'
            this.inputOldRetailPrice = '0'
            this.inputOldWholesalesPrice = '0'
            this.inputOldLeastPrice = '0'
            this.inputOldSpecialPrice = '0'

            if (component_x.targetKey >= 0) {
                const newData = [...this.targetData];
                const target = newData.filter(item => this.targetKey === item.key)[0];
                if (target) {
                    this.inputSiteId = target["key"];
                    this.inputSiteId = target["site_id"];
                    this.inputSupplierId = target["supplier_id"];
                    this.inputOriginalCost = target["original_cost"];
                    this.inputOldOriginalCost = target["original_cost"];
                    this.inputOrderingCost = target["ordering_cost"];
                    this.inputOldOrderingCost = target["ordering_cost"];
                    this.inputLandedCost = target["landed_cost"];
                    this.inputOldLandedCost = target["landed_cost"];
                    this.inputLastDiscount = target["last_discount_text"];
                    this.inputRetailPrice = target["retail_price"];
                    this.inputOldRetailPrice = target["retail_price"];
                    this.inputMarkupRetail = target["markup_percent"];
                    this.inputWholesalesPrice = target["wholesale_price"];
                    this.inputOldWholesalesPrice = target["wholesale_price"];
                    this.inputLeastPrice = target["least_price"];
                    this.inputOldLeastPrice = target["least_price"];
                    this.inputSpecialPrice = target["special_price"];
                    this.inputOldSpecialPrice = target["special_price"];
                }
            }

            component_x.spinning = false;
        },
        props:['targetData', 'targetKey', 'product', 'currentSiteId', 'constrainedMode'],
        data: function () {
            return {
                errors: [],
                formSettings: { isAdmin: false },

                //set value
                markup_computation: "1",
                enable_auto_compute_price_on_markup: true,
                cost_decimal_places: 2,

                inputSiteId: null,
                siteOptions: [],
                inputSupplierId: this.product.supplier_id,
                supplierOptions: [],

                inputOriginalCost: '',
                inputOldOriginalCost: '',
                inputOrderingCost: '',
                inputOldOrderingCost: '',
                inputLandedCost: '',
                inputOldLandedCost: '',
                inputLastDiscount: '',
                inputRetailPrice: '',
                inputOldRetailPrice: '',
                inputMarkupRetail: '',
                inputWholesalesPrice: '',
                inputOldWholesalesPrice: '',
                inputMarkupWholesale: '',
                inputLeastPrice: '',
                inputOldLeastPrice: '',
                inputMarkupLeast: '',
                inputSpecialPrice: '',
                inputOldSpecialPrice: '',
                inputMarkupSpecial: '',
                site_product: [],
                spinning: false
            }
        },
        methods: {
            filterOption(input, option) {
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            sort(data){
                data.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });
            },
            changeAmount(e) {
                let name = e.target.name
                let x = 0;
                if (name == 'original'){
                    x = this.fixedCostDecimal(this.inputOriginalCost);
                    this.inputOriginalCost = x;
                } else if (name == 'ordering'){
                    x = this.fixedCostDecimal(this.inputOrderingCost);
                    this.inputOrderingCost = x;
                } else if (name == 'landed'){
                    x = this.fixedCostDecimal(this.inputLandedCost);
                    this.inputLandedCost = x;
                }
            },
            fixedCostDecimal(value){
                if (this.isBlankCost(value)) {
                    return null;
                }
                let val = Number(value)
                let x = val.toFixed(this.cost_decimal_places);
                return x;
            },
            isBlankCost(value) {
                return value === "" || value === null || value === undefined;
            },
            costInputValue(value) {
                return this.isBlankCost(value) ? null : value;
            },
            computePrice(e) {
                let name = e.target.name
                let y = 0;
                let z = 0;
                if (this.enable_auto_compute_price_on_markup == true){
                    if (name == 'special'){
                        y = this.inputMarkupSpecial;
                        if (this.inputSpecialPrice == "") {
                            z = this.baseComputation(y);
                            this.inputSpecialPrice = z;
                        }
                    } else if (name == 'wholesale'){
                        y = this.inputMarkupWholesale;
                        if (this.inputWholesalesPrice == "") {
                            z = this.baseComputation(y);
                            this.inputWholesalesPrice = z;
                        }
                    } else if (name == 'least'){
                        y = this.inputMarkupLeast;
                        if (this.inputLeastPrice == "") {
                            z = this.baseComputation(y);
                            this.inputLeastPrice = z;
                        }
                    } else {
                        y = this.inputMarkupRetail;
                        if (this.inputRetailPrice == "") {
                            z = this.baseComputation(y);
                            this.inputRetailPrice = z;
                        }
                    }
                }
            },
            baseComputation(y){
                var x = this.inputLandedCost;
                var z = 0;
                var based_on = this.markup_computation;

                if(based_on == "1"){
                    z = x / (1 - ( y / 100));
                } else {
                    z = x * ( 1 + ( y / 100));
                }
                return z.toFixed(2);
            },
            validateForm(){
                this.errors = [];
                if(this.inputSiteId == null){
                  this.errors.push("Site is required");
                }

                if(this.inputSupplierId == null){
                  this.errors.push("Supplier is required");
                }

                if (this.targetData.find(x => x.site_id === this.inputSiteId) && this.targetKey < 0){
                  this.errors.push("Selected Site has existing prices already.");
                }

                this.errors = this._.compact(this.errors);
                document.getElementsByClassName('ant-drawer-wrapper-body')[0].scrollTop = 0;
                return this.errors.length;
            },
            create: async function () {
              
                if(!this.validateForm()) {
                    var site_data = {
                      key: this.inputSiteId,
                      site_id: this.inputSiteId,
                      supplier_id: this.inputSupplierId,
                      site_name: this.siteOptions.find(x => x.id === this.inputSiteId).name,
                      original_cost: this.costInputValue(this.inputOriginalCost),
                      ordering_cost: this.costInputValue(this.inputOrderingCost),
                      landed_cost: this.costInputValue(this.inputLandedCost),
                      last_discount_text: this.inputLastDiscount,
                      retail_price: this.inputRetailPrice,
                      markup_percent: this.inputMarkupRetail,
                      wholesale_price: this.inputWholesalesPrice,
                      least_price: this.inputLeastPrice,
                      special_price: this.inputSpecialPrice,
                    };
                    this.site_data = site_data
                    this.$emit('setTargetData', site_data)
                    this.$emit('closeDrawer')
                }
            },
            update: async function () {
                if(!this.validateForm()) {
                    this.site_product = this.targetData
                    const newData = [...this.site_product];
                    const target = newData.filter(item => this.targetKey === item.key)[0];
                    if (target) {
                        target["key"] = this.inputSiteId,
                        target["site_id"] = this.inputSiteId,
                        target["supplier_id"] = this.inputSupplierId,
                        target["site_name"] = this.siteOptions.find(x => x.id === this.inputSiteId).name,
                        target["original_cost"] = this.costInputValue(this.inputOriginalCost),
                        target["old_original_cost"] = this.inputOldOriginalCost,
                        target["ordering_cost"] = this.costInputValue(this.inputOrderingCost),
                        target["old_ordering_cost"] = this.inputOldOrderingCost,
                        target["landed_cost"] = this.costInputValue(this.inputLandedCost),
                        target["old_landed_cost"] = this.inputOldLandedCost,
                        target["last_discount_text"] = this.inputLastDiscount,
                        target["retail_price"] = this.inputRetailPrice,
                        target["old_retail_price"] = this.inputOldRetailPrice,
                        target["markup_percent"] = this.inputMarkupRetail,
                        target["wholesale_price"] = this.inputWholesalesPrice,
                        target["old_wholesale_price"] = this.inputOldWholesalesPrice,
                        target["least_price"] = this.inputLeastPrice,
                        target["old_least_price"] = this.inputOldLeastPrice,
                        target["special_price"] = this.inputSpecialPrice,
                        target["old_special_price"] = this.inputOldSpecialPrice
                    }
                    this.site_product = newData;
                    this.$emit('updateTargetData', this.site_product)
                    this.$emit('closeDrawer')
                }
            }
        }
    }
</script>

<style>
</style>
